import VwoABTest from './dynamicTestPlataform/vwoABTest'
import vwoCampaignKeyEnum from './dynamicTestPlataform/vwoCampaignKeyEnum'
import vwoTrackKeyEnum from './dynamicTestPlataform/vwoTrackKeyEnum'
import { NAM_COUNTRIES_ENUM } from './nam-countries-enum'

const MAX_DAILY_FOR_DOMESTIC_CAMPAIGN = 27

export default {
  methods: {
    async setVwoProgressionFromConfigToPaymentStep() {
      try {
        const metricConfig = {
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_DOMESTIC]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_DOMESTIC,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_OUTBOUND]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_OUTBOUND,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_LATAM]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_LATAM,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_ROW]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_VIEW_PAYMENT_ROW
        }

        await this.setVwoTrackABTest(metricConfig)
      } catch (error) {
        this.$bugsnag.notify(error)
      }
    },

    async setVwoBookingConversion() {
      try {
        const metricConfig = {
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_DOMESTIC]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_DOMESTIC,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_OUTBOUND]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_OUTBOUND,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_LATAM]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_LATAM,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_ROW]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_ROW
        }

        const trackProperties = {
          eventProperties: {
            bookingId: this.reservation?.Booking?.Code,
            revenue: this.reservation?.Commission?.GA4?.total_revenue
          }
        }

        await this.setVwoTrackABTest(metricConfig, trackProperties)
      } catch (error) {
        this.$bugsnag.notify(error)
      }
    },

    async setVwoBookingConversionWithRentalCover() {
      try {
        const metricConfig = {
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_DOMESTIC]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_DOMESTIC,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_OUTBOUND]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_OUTBOUND,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_LATAM]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_LATAM,
          [vwoCampaignKeyEnum.STEP_PROTECTIONS_ROW]: vwoTrackKeyEnum.METRIC_KEY_PROTECTIONS_BOOKING_CONVERSION_RC_ROW
        }

        const trackProperties = {
          eventProperties: {
            bookingId: this.reservation?.Booking?.Code,
            revenue: this.reservation?.Commission?.GA4?.total_revenue,
            rentalcoverRevenue: parseFloat(this.reservation.RentalCover.Value)
          }
        }

        await this.setVwoTrackABTest(metricConfig, trackProperties)
      } catch (error) {
        this.$bugsnag.notify(error)
      }
    },

    async getCampaignStepProtections() {
      const hasRentalCover = this.hasRentalCover()
      const residenceCode = this.$route.params.residenceCode || await this.$store.getters.getUserResidenceCountry
      const itinerary = this.$store.getters['search/getItinerary']
      const itineraryConditionToStop = itinerary.IsDomestic && itinerary.Daily > MAX_DAILY_FOR_DOMESTIC_CAMPAIGN

      if (!hasRentalCover || this.isNamCountry(residenceCode) || itineraryConditionToStop) {
        return false
      }

      if (itinerary.IsDomestic) {
        return vwoCampaignKeyEnum.STEP_PROTECTIONS_DOMESTIC
      }

      if (residenceCode === 'BR' && !itinerary.IsDomestic) {
        return vwoCampaignKeyEnum.STEP_PROTECTIONS_OUTBOUND
      }

      if (this.isLatamCountry(residenceCode)) {
        return vwoCampaignKeyEnum.STEP_PROTECTIONS_LATAM
      }

      return vwoCampaignKeyEnum.STEP_PROTECTIONS_ROW
    },

    async setVwoTrackABTest(metricConfigMap, options = {}) {
      const vwoCampaignKey = await this.getCampaignStepProtections()

      if (!vwoCampaignKey) {
        return false
      }

      const userCookieUuid = this.$appCookie.get('userUuid')

      const vwoAbTest = new VwoABTest()
      return await vwoAbTest.setVwoTrackABTest(
        userCookieUuid,
        vwoCampaignKey,
        metricConfigMap[vwoCampaignKey],
        options
      )
    },

    isNamCountry(residenceCode) {
      return Object.values(NAM_COUNTRIES_ENUM).includes(residenceCode)
    },

    hasRentalCover() {
      const bookingConfig = this.$store.getters['booking/getBookingPageConfigurePayOnConfigure']

      if (bookingConfig.rentalCover !== null) {
        return true
      }

      return bookingConfig?.ServicosAdicionais?.RentalCover?.Disponivel || false
    }
  }
}
